var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10227IconServiceManagedIdentities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f807cdde-18f2-4574-ba14-f0b1eef94a4a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb67b154-af8f-4a53-a9ce-aa046b9398e9",
    x1: 13.18,
    y1: 13.01,
    x2: 8.63,
    y2: 4.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1988d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#54aef0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a47d7138-084a-471d-8d63-744e75b9e8a3",
    x1: 11.22,
    y1: 10.5,
    x2: 14.37,
    y2: 15.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#54aef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4fabee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#41a2e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2a93e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#1988d9"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-identity-227") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1.15 10.22 8.93 15.27 16.85 10.21 17.85 11.36 8.93 17.11 0.15 11.37 1.15 10.22",
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1.73 9.58 8.93 1 16.28 9.59 8.93 14.23 1.73 9.58",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.93 1 8.93 14.23 1.73 9.58 8.93 1",
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.93 1 8.93 14.23 16.28 9.59 8.93 1",
    fill: "url(#bb67b154-af8f-4a53-a9ce-aa046b9398e9)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.93 7.83 16.28 9.59 8.93 14.23 8.93 7.83",
    fill: "#53b1e0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.93 14.23 1.73 9.58 8.93 7.83 8.93 14.23",
    fill: "#9cebff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.93 17.11 17.85 11.36 16.85 10.21 8.93 15.27 8.93 17.11",
    fill: "url(#a47d7138-084a-471d-8d63-744e75b9e8a3)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "e189a61f-631a-4122-bb2b-079e86004d96",
    d: "M16.32,11.88a1.16,1.16,0,0,0,0-1.65h0l-2-2a1.16,1.16,0,0,0-1.64,0h0l-2,2a1.18,1.18,0,0,0,0,1.65l1.67,1.67a.32.32,0,0,1,.09.23v3.1a.36.36,0,0,0,.12.28l.76.76a.25.25,0,0,0,.37,0l.73-.73h0l.44-.44a.15.15,0,0,0,0-.21l-.31-.31a.16.16,0,0,1,0-.24l.31-.31a.16.16,0,0,0,0-.22l-.31-.31a.15.15,0,0,1,0-.23l.31-.32a.15.15,0,0,0,0-.21l-.44-.44v-.16ZM13.5,8.71a.66.66,0,1,1-.66.66.66.66,0,0,1,.66-.66Z",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fb7033ee-4650-4886-80c7-eddf62560f85",
    d: "M13,17h0a.14.14,0,0,0,.24-.11V14.33a.16.16,0,0,0-.06-.13h0a.14.14,0,0,0-.22.13v2.51A.15.15,0,0,0,13,17Z",
    fill: "#ff9300",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b166b8c2-b9ee-4c3d-bf7a-77bd5ce0570b",
    x: 11.9,
    y: 10.9,
    width: 3.29,
    height: 0.39,
    rx: 0.18,
    fill: "#ff9300",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "baf437fe-3483-4a25-94ba-1e84a64cd2eb",
    x: 11.9,
    y: 11.53,
    width: 3.29,
    height: 0.39,
    rx: 0.18,
    fill: "#ff9300",
    opacity: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10227IconServiceManagedIdentities);
export default __webpack_public_path__ + "static/media/10227-icon-service-Managed-Identities.aea1bf4b211c6adc9ce14f9a420be3b9.svg";
export { ForwardRef as ReactComponent };